module.exports = __webpack_public_path__ + "static/media/Electrificacion_Hogar.d52d78d6.png";